import axios from "axios"
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import { hassAccess } from "../../base/utils";
import moment from "moment-timezone";
import { config } from "../../base/constant";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { CallServices } from "../../base/service/apiServices";
import { v4 as uuidv4 } from 'uuid';

export const getPriviousChannelSummary = (dispatch: any, data: { coid: number, currentSessionId: any }) => {
    try {
        const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

        if (!data?.coid || !hassAccess('previousChatSummary')) return;
        const body = {
            "CustomerId": data?.coid, 
            "domainId": loginUserCcaasDetail?.domainId,
            "currentSessionId": data?.currentSessionId
        }
        // axios.post("http://46.43.144.145:7037/customer_previous_chat_summary", body)
        axios.post(config().PRIVIOUS_CHAT_SUMMARY, body)
            .then((responsed) => {
                if (responsed?.data?.status_code === 200) {
                    const data = responsed?.data
                    const timeFormat = data?.lastUpdatedAt ? moment(`${data?.lastUpdatedAt}.000Z`).format('DD-MM-YYYY hh:mm A') : '-'
                    let payload = {
                        message: data?.message || "",
                        pastSessionId: data?.pastSessionId?.trim() || "",
                        attend: data?.agentName || "Automatic",
                        time: timeFormat,
                        currentSessionId: data?.currentSessionId || "",
                        channel_type: data?.channel_type || ""
                    }
                    dispatch(ChatActions.setCustomerPreviousHistory(payload))
                }
            })
            .catch((err)=> console.log(err))
    } catch (error) {
        console.log(error)
    }
}

export const setAngryNotification = (LoginCcaasUserDetails: any, userList: any) => {
    try {
        if (Array.isArray(userList) && userList?.length > 0) {
            const reportingToData = userList.find((user) => user.UserID === LoginCcaasUserDetails?.report_to_UserID)
            if (reportingToData?.ext) {
                const payloadForNotification = {
                    uuid: uuidv4(),
                    toExt: reportingToData?.ext,
                    notificationMsg: `Customer sentiment detected as Negative. ${LoginCcaasUserDetails?.UserName || "Agent"} is handling this case. Immediate coaching recommended`,
                    channelType: 'All',
                    markAsRead: 0,
                    type: 'User Anger Reported',
                }
                CallServices
                    .post(payloadForNotification, "/insert_notificationmsg")
                    .catch((error) => console.log('insert_notificationmsg', error))
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const checkCurrentSessionChannel = (currentSession :any, channelName :any[]) => {
    try {
        if(!Array.isArray(channelName)) return false;
        return (
            channelName.includes(currentSession?.channeltype) 
            || channelName.includes(currentSession?.channelType)
        )
    } catch (error) {
       return false
    }
}